import { render, staticRenderFns } from "./slideVerify.vue?vue&type=template&id=08a0b912&scoped=true"
import script from "./slideVerify.vue?vue&type=script&lang=ts"
export * from "./slideVerify.vue?vue&type=script&lang=ts"
import style0 from "./slideVerify.vue?vue&type=style&index=0&id=08a0b912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0b912",
  null
  
)

export default component.exports